import React, { useMemo } from 'react';
import { Card, CardBody, CardHeader, CardHeaderToolbar } from '../../../../../../_metronic/_partials/controls';
import { usePeriodeKurbanUIContext } from './PeriodeKurbanUIContext';
import PeriodeKurbanTable from './periode-kurban-table/PeriodeKurbanTable';
import { PeriodeKurbanFilter } from './periode-kurban-table/periode-kurban-filter/PeriodeKurbanFilter'
import { RoleChecker } from '../../../../../RoleChecker';

export const PeriodeKurbanCard = () => {

	const periodeKurbanUIContext = usePeriodeKurbanUIContext();
	const periodeKurbanUIProps = useMemo(() => {
		return {
			newPeriodeKurbanButtonClick: periodeKurbanUIContext.newPeriodeKurbanButtonClick,
		};
	}, [periodeKurbanUIContext]);

	return (
		<Card>
			<CardHeader title="Periode Kurban List">
				<CardHeaderToolbar>
					{RoleChecker('Create', 'access_role') && <button
						type="button"
						className="btn btn-primary"
						onClick={periodeKurbanUIProps.newPeriodeKurbanButtonClick}
					>Periode Kurban Baru
					</button>}
				</CardHeaderToolbar>
			</CardHeader>
			<CardBody>
				<PeriodeKurbanFilter />
				<PeriodeKurbanTable />
			</CardBody>
		</Card>
	);
};
